module.exports = __webpack_public_path__ + "static/media/logo_wal_hashtag.07c4e53d.png";